var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('modal-social-share-list'), _c('modal-multi-bill-edit'), _c('refund-confirm-modal'), _c('ticket-template-dialog'), _c('tips-variants-dialog'), _c('declaration-description-dialog'), _c('transaction-receipt-modal'), _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_vm.isPersonalProject ? _c('cabinet-notification', {
    directives: [{
      name: "m-b",
      rawName: "v-m-b",
      value: 20,
      expression: "20"
    }]
  }) : _vm._e(), _c('project-dashboard'), _c('transaction-filters', {
    ref: "TransactionFilters",
    on: {
      "toggle-block": _vm.toggleBillCreated
    }
  }), _c('div', {
    staticClass: "report-list-container"
  }, [_c('report'), _vm.isDeviceSize.desktop ? _c('notice') : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }